<template>
  <div>

    <navbar></navbar>

    <div class="bg-header-round-small">
      <div class="container">
        <h1>Account aktivieren</h1>
      </div>
    </div>

    <div class="container" >
      <cg-loader :show="showLoader" :message="message"></cg-loader>
      <p v-if="verificationFailed">
        Vielleicht ist der Aktivierungslink schon abgelaufen? <a href="#" @click.prevent="resendVerificationMail">Hier kannst Du einen neuen Aktivierungslink beantragen!</a>
        <br>
        Du kannst Dich auch jederzeit an unseren <a href="/service/contact" @click.prevent="goTo('service.contact')">Support</a> wenden.
      </p>
    </div>
    <cgfooter></cgfooter>

  </div>
</template>

<script>
  import Navbar from '../components/Navbar.vue'
  import CgFooter from '../components/CgFooter.vue'
  import helpers from '@/mixins/helpers.js'
  import formatting from '@/mixins/formatting.js'

  import { mapGetters, mapActions } from 'vuex'
  import CgLoader from '../components/menus/cgLoader'

  export default {
    name: 'VerifyAccount',
    components: {
      CgLoader,
      'navbar': Navbar,
      'cgfooter': CgFooter
    },
    mixins: [formatting, helpers],
    data () {
      return {
        verificationFailed: false,
        showLoader: true,
        message: 'Deine Email Adresse wird verifiziert ...'
      }
    },
    created () {
      var self = this
      var payload = {
        'token': self.$route.params.token,
        cb () {
          self.$toasted.success('Dein Account ist jetzt verifizert - viel Spass bei couchgourmet!', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'fingerprint'
          })
          self.goTo('home')
        },
        errorCb () {
          self.message = 'Deine Email Adresse konnte leider nicht verifiziert werden.'
          self.showLoader = false
          self.verificationFailed = true
          self.$toasted.error('Deine Email Adresse konnte leider nicht verifiziert werden.', {
            theme: 'primary',
            position: 'top-right',
            duration: 10000,
            action: {
              text: 'X',
              class: 'toastBtn',
              onClick: (e, toastObject) => {
                toastObject.goAway(0)
              }
            },
            icon: 'fingerprint'
          })
        }
      }
      this.verifyAccount(payload)
    },
    methods: {
      resendVerificationMail () {
        console.log('resendVerificationMail')
      },
      ...mapActions([
        'verifyAccount'
      ])
    },
    computed: {
      ...mapGetters({
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/VerifyAccount.vue